'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _CoverageRecipientsList = require('components/Statistics/CoverageRecipientsList/CoverageRecipientsList');

var _CoverageRecipientsList2 = _interopRequireDefault(_CoverageRecipientsList);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ChartNoData = require('components/Statistics/ChartNoData/ChartNoData');

var _ChartNoData2 = _interopRequireDefault(_ChartNoData);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CoverageRecipientsListWrapper = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activeOrder: state.statistics.coverageRecipientsActiveOrder,
    order: state.statistics.coverageRecipientsOrder
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(CoverageRecipientsListWrapper, _Component);

  function CoverageRecipientsListWrapper() {
    (0, _classCallCheck3.default)(this, CoverageRecipientsListWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientsListWrapper.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientsListWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(CoverageRecipientsListWrapper, [{
    key: 'reorder',
    value: function reorder(name) {
      this.props.coverageRecipientsReorder(name);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          recipients = _props.recipients,
          activeOrder = _props.activeOrder,
          order = _props.order,
          columns = _props.columns,
          loading = _props.loading,
          showLoader = _props.showLoader,
          projectId = _props.projectId;


      var hasData = recipients.length;
      if (loading) {
        return showLoader ? _react2.default.createElement(_Loader2.default, { alignCenter: true }) : null;
      } else if (!hasData) {
        return _react2.default.createElement(_ChartNoData2.default, { className: 'padding-10' });
      }

      return _react2.default.createElement(_CoverageRecipientsList2.default, {
        className: className,
        columns: columns,
        recipients: recipients,
        activeOrder: activeOrder,
        order: order,
        onReorder: this.reorder,
        projectId: projectId
      });
    }
  }]);
  return CoverageRecipientsListWrapper;
}(_react.Component), _class3.propTypes = {
  activeOrder: _propTypes2.default.string,
  className: _propTypes2.default.string,
  columns: _propTypes2.default.array,
  coverageRecipientsReorder: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  order: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  recipients: _propTypes2.default.array,
  showLoader: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype)), _class2)) || _class);
exports.default = CoverageRecipientsListWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/CoverageRecipientsListWrapper/CoverageRecipientsListWrapper.js
// module id = 2210
// module chunks = 1